import React from "react";
import { ChevronDown } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function VisualStorytellingIdentity() {
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll();
  const {
    ref: subheadRef,
    isVisible: subheadVisible
  } = useRevealOnScroll({
    threshold: 0.5
  });
  const {
    ref: scrollRef,
    isVisible: scrollVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="5733" id="the-future-of-activewear" className="bg-background text-foreground relative h-screen w-full overflow-hidden flex flex-col items-center justify-center" style={{
    clipPath: "polygon(0 0, 100% 0, 100% 90%, 0 100%)"
  }}>
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-secondary/40 z-10" /> {}
        <video autoPlay muted loop playsInline poster="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1610560/img/design_sketches_bg.png" className="h-full w-full object-cover opacity-50">
          {}
          <source src="" type="video/mp4" />
        </video>
        {}
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1610560/img/design_sketches_bg.png)] bg-cover bg-center opacity-10 mix-blend-multiply z-0" />
      </div>

      {}
      <div className="relative z-20 container mx-auto px-4 flex flex-col items-center text-center">
        
        {}
        <div ref={headlineRef} className={`flex flex-col items-center justify-center transition-all duration-1000 ease-out transform ${headlineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <h1 className="text-6xl md:text-8xl lg:text-9xl font-black tracking-tighter leading-none font-sans">
            <span className="block text-transparent" style={{
            WebkitTextStroke: "2px var(--color-secondary)"
          }}>
              100% CIRCULAR
            </span>
            <span className="block text-primary mt-2 md:mt-4 drop-shadow-xl">
              ACTIVEWEAR
            </span>
          </h1>
        </div>

        {}
        <div ref={subheadRef} className={`mt-8 max-w-2xl transition-all duration-1000 delay-300 ease-out transform ${subheadVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <p className="text-lg md:text-xl font-medium text-secondary/80 font-sans tracking-wide">
            High-performance gear engineered from recycled materials. EcoThread blends sustainability with vibrant style for families, fans, and athletes.
          </p>
        </div>

      </div>

      {}
      <div ref={scrollRef} className={`absolute bottom-12 md:bottom-24 left-1/2 -translate-x-1/2 z-20 transition-all duration-1000 delay-700 ease-out ${scrollVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
        <Link to="#design-vault" className="group flex flex-col items-center gap-2 text-sm font-bold tracking-widest uppercase text-secondary/60 hover:text-primary transition-colors font-sans">
          <span>Scroll to Discover</span>
          <div className="relative flex items-center justify-center size-10 rounded-full border border-secondary/10 bg-primary/5 backdrop-blur-sm shadow-[0_0_15px_rgba(var(--color-primary),0.2)] group-hover:shadow-[0_0_25px_rgba(var(--color-primary),0.5)] group-hover:border-primary/50 transition-all duration-300">
            <ChevronDown className="size-5 animate-bounce text-primary" />
          </div>
        </Link>
      </div>

      {}
      <div className="absolute top-0 left-0 w-full h-32 bg-gradient-to-b from-background to-transparent z-10 pointer-events-none" />
      <div className="absolute bottom-0 left-0 w-full h-32 bg-gradient-to-t from-background/40 to-transparent z-10 pointer-events-none" />
    </section>;
}